import SKILLS from '../data/skills';
import STATS from '../data/stats';

// ─── SKILL HELPERS ──────────────────────────────────────────────────────────

export function getAllSkills() {
  return [...SKILLS.might, ...SKILLS.speed, ...SKILLS.intellect];
}

// ─── STAT HELPERS ───────────────────────────────────────────────────────────

export function getStatColor(statId) {
  const s = STATS.find(st => st.id === statId);
  return s ? s.color : "#c9a84c";
}

// ─── TIME HELPERS ───────────────────────────────────────────────────────────

export function getTimeAgo(date) {
  const seconds = Math.floor((new Date() - date) / 1000);

  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 4) return `${weeks}w ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return `${months}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}
